import Store from 'store/store';
import parseQueryString from 'utils/parseQueryString';

let apiBase = 'https://api.scan-primepremiere.powster.com';
// if (__IS_LOCAL__ || __IS_DEMO__) {
// 	apiBase = 'https://event-ticketing-test-s.pow.io';
// }
if (__IS_LOCAL__ && parseQueryString().localserver) {
	apiBase = 'http://localhost:3000';
}
export { apiBase as API_BASE };

const localCookiesName = 'event-ticketing-auth-token-local';
export function setTokenInLocalCookies(token) {
	try {
		document.cookie = `${localCookiesName}=${token}; Max-Age=86400; Path=/`;
	} catch (e) {}
}
export function removeLocalCookiesToken() {
	try {
		document.cookie = `${localCookiesName}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT`;
	} catch (e) {}
}
function getLocalCookiesToken() {
	try {
		const cookies = document.cookie.split(/\s*;\s*/);
		for (let cookie of cookies) {
			const [name, value] = cookie.split('=');
			if (name === localCookiesName) {
				return value;
			}
		}
	} catch (e) {}
	return null;
}

export function getApiUrl(path) {
	return new URL(path, apiBase).href;
}

function apiError(res) {
	const error = new Error(res?.statusText || res?.status || 'Error');
	error.code = res?.status || 500;
	return error;
}

async function fetchRaw(url, options) {
	if ((__IS_LOCAL__ || __IS_DEMO__) && parseQueryString().dummy) {
		let dummy = await import('utils/dummy');
		let res = dummy.routes[url.pathname];
		if (typeof res === 'function') {
			res = await res(url, options);
		} else {
			await new Promise(res => setTimeout(res, 100 + Math.random() * 1000));
		}
		if (!res || res instanceof Error) {
			throw res || apiError({ status: 404 });
		}
		return res;
	}
	let res = await fetch(url.href, options);
	if (!res.ok) {
		throw apiError(res);
	}
	return res.json();
}

export async function request(path, options = {}) {
	let url = new URL(path, apiBase);
	if (options.qs) {
		url.search = new URLSearchParams(options.qs).toString();
		delete options.qs;
	}
	try {
		const headers = { ...options?.headers };
		const token = getLocalCookiesToken();
		if (token) {
			headers.authorization = `Bearer ${token}`;
		}
		return await fetchRaw(url, { ...options, credentials: 'include', headers });
	} catch (err) {
		if (err?.code === 401) {
			Store.emit('REQUEST_LOGIN');
		}
		throw err;
	}
}

export async function post(path, body, options) {
	return request(
		path,
		{
			...options,
			method: 'POST',
			body: !body || typeof body === 'string' ? body || '{}' : JSON.stringify(body),
			headers: { 'Content-Type': 'application/json', ...options?.headers },
		}
	);
}